import type { Dictionnaire } from '../type';

export const commun: Dictionnaire['commun'] = {
  annuler: 'Cancelar',
  oui: 'Sí',
  actions: 'Acciones',
  confirmer: 'Confirmar',
  retour: 'Volver',
  reessayer: 'Reintentar',
  pleinEcran: 'Foto a pantalla completa',
  fermer: 'Cerrar',
  enLigne: 'En línea',
  erreur: 'Algo ha fallado',
  serveur: {
    refuse: 'Este mensaje no respeta las normas de la comunidad.',
    invalide: 'Mensaje no válido',
    accesRefuse: 'Acceso denegado.',
    indisponible: 'No se puede publicar ahora mismo. Vuelve a intentarlo en un momento.',
  },
  choisisUnSpot: 'Elige primero un spot',
  membreInconnu: 'Miembro desconocido',
  quelquun: 'Alguien',
  nonConfigure: 'Firebase no está configurado. Rellena client/.env.local (ver client/.env.example).',
  unInstant: 'Un momento…',
  envoi: 'Enviando…',
  uneLangue: 'Elige al menos un idioma.',
};
